import React, { Component } from 'react';
interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };
  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      error
    };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      return <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900" data-id="element-259">
          <div className="text-center max-w-lg p-8 bg-white dark:bg-gray-800 rounded-xl shadow-lg" data-id="element-260">
            <h1 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4" data-id="element-261">
              Something went wrong
            </h1>
            <p className="text-gray-700 dark:text-gray-300 mb-6" data-id="element-262">
              We're sorry, but an error occurred while loading this page.
            </p>
            <div className="p-4 bg-red-50 dark:bg-red-900/20 rounded-lg mb-6 text-left overflow-auto max-h-40" data-id="element-263">
              <pre className="text-sm text-red-700 dark:text-red-300" data-id="element-264">
                {this.state.error?.toString()}
              </pre>
            </div>
            <button onClick={() => window.location.reload()} className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-265">
              Reload Page
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}